<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addCar()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.cars.length == 0"
  message="Per questo itinerario non è ancora stato inserito alcun mezzo."
  actionIcon="add"
  actionLabel="Aggiungi un mezzo"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
  (actionClick)="addCar()"
>
  <p>
    <small
      >Per il noleggio auto, utilizza
      <a href="https://www.rentalcars.com" target="_blank">Rentalcars.com</a
      >.</small
    >
  </p>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let car of itinerary.reservations.cars; index as carId"
    [(expanded)]="expanded[carId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">{{
          getCarTypeData(car.type)?.icon
        }}</mat-icon>
        <span class="header-title" fxFlex>
          <app-itinerary-reservations-car-form-title
            [car]="car"
          ></app-itinerary-reservations-car-form-title>
        </span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questo mezzo"
            (click)="removeCar($event, car)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-car-form
      [car]="car"
      [carId]="carId"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-reservations-car-form>
  </mat-expansion-panel>
</mat-accordion>
